import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Globals } from 'projects/core/src/globals';
import { ModelList } from 'projects/core/src/include/modellist';
import { Installation } from '../../../../db/installation';
import { InstallationsService } from '../../../../services/installations.service';
import { SerialsDetailsComponent } from '../serials-details/serials-details.component';
import { SerialsComponent } from '../serials.component';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { Type } from 'projects/c1-backend/src/app/db/type';
import { Filter, FilterMode } from 'projects/core/src/include/structures';

@Component({
  selector: 'app-serialshop',
  templateUrl: './serialshop.component.html',
  styleUrls: ['./serialshop.component.css']
})
export class SerialshopComponent extends ModelList<Installation> implements OnInit  {
    modulename="installations";


  @Input()
  id_shop:number=0;

  @Input()
  id_address:number=0;

  type_product:Type[]=[];
  
  showNotAssigned=false;
  filter_id_type:Filter=new Filter();
  

  constructor(
    private fb1: UntypedFormBuilder,
    private installationsService: InstallationsService,
    private typesService:TypesService
    
  ) {
    super(installationsService,fb1);
    this.detailViewModal=SerialsDetailsComponent;
    
   }

  ngOnInit(): void {
    super.ngOnInit.apply(this, arguments); 

    this.filter_id_type.mode=FilterMode.contain;
    this.filter_id_type.fields=[];
    this.filter_id_type.fields.push("p.id_type");
    this.filter_id_type.value=this.module?.getParam("default_type","");
    this.filter.push(this.filter_id_type);

    this.typesService.getTypes("installations").subscribe((items)=>{
      this.type_product=items;
    })
    if(this.id_shop>0 || this.id_address>0)
    this.updateList();
    

  }

  ngOnChanges():void{
    
    //if(this.id_shop>0 || this.id_address>0)
      //this.updateList();
  }

  updateList(){
    

    this.installationsService.getInstallationByShop(this.id_shop,this.id_address,this.filter_id_type.value).subscribe((items)=>{
      this.list=items;
    })
  }

  getItems(){
    this.updateList();
  }


  addInstallation(){
    Globals.modal.showModal(SerialsDetailsComponent,[{"name":"mode","value":"modal"},{"name":"id_shop","value":this.id_shop}],(instance)=>{
      if(instance!=null){
        this.updateList();
      }
    })
  }


  isShow(record){
    if(this.showNotAssigned){
      return true
    }else{
      if(this.id_shop==record.current_id_shop || this.id_address==record.current_id_address){
        return true;
      }
    }
    return false;
  }

}
